// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M8.5,9.9l-2.8,2.8l0,0l-1.1,1.1c-0.6,0.6-0.6,1.5,0,2.1l0,0L6,17.3l-3.8,3.9l0.7,0.7L6.7,18l1.4,1.4
		c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.2,1.1-0.4l1.1-1.1l0,0l2.8-2.8L8.5,9.9z M9.5,18.7c-0.2,0.2-0.5,0.2-0.7,0l-3.5-3.5
		c-0.2-0.2-0.2-0.5,0-0.7l0.4-0.4l4.2,4.2L9.5,18.7z M6.3,13.4l2.1-2.1l4.2,4.2l-2.1,2.1L6.3,13.4z M15.9,4.6
		c-0.6-0.6-1.5-0.6-2.1,0l0,0L11.3,7l1.4,1.4l-2.1,2.1l0.7,0.7l2.1-2.1l1.4,1.4l-2.1,2.1l0.7,0.7l2.1-2.1l1.5,1.4l2.5-2.5
		c0.6-0.6,0.6-1.5,0-2.1l0,0L15.9,4.6z M18.7,9.5L17,11.3L12.7,7l1.8-1.8C14.7,5,15,5,15.2,5.2l3.5,3.5C18.9,9,18.9,9.3,18.7,9.5z
		 M8.5,12.7l0.7,0.7l-0.7,0.7l-0.7-0.7L8.5,12.7z M11.3,15.5l-0.7,0.7l-0.7-0.7l0.7-0.7L11.3,15.5z M18,6.7L17.3,6l3.9-3.8l0.7,0.7
		L18,6.7z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-plug-CnDTrLiy.js.map
